import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Apply from './pages/Apply';
import Development from './pages/Development';
import Download from './pages/Download';
import Register from './pages/Register';
import Rankings from './pages/Rankings';
import Login from './pages/Login';
import Account from './pages/Account';
import ForgotUsername from './pages/ForgotUsername';
import ResetPassword from './pages/ResetPassword';
import ResetPIC from './pages/ResetPIC';
import SkillCalculator from './pages/SkillCalculator';

function RouteEffects() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const titles: Record<string, string> = { '/': 'Explore Daruma', '/apply': 'Join private testing', '/development': 'Development updates', '/register': 'Create an account', '/download': 'Download', '/login': 'Log in', '/rankings': 'Rankings', '/skills': 'Skills', '/account': 'Your account', '/forgot-username': 'Recover username', '/reset-password': 'Reset password', '/reset-pic': 'Reset PIC' };
    document.title = `${titles[pathname] || 'Page not found'} · Maple Daruma`;
    document.getElementById('main-content')?.focus({ preventScroll: true });
  }, [pathname]);
  return null;
}
function App() {
  return (
    <Router>
      <RouteEffects />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main id="main-content" tabIndex={-1} className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/development" element={<Development />} />
            <Route path="/download" element={<Download />} />
            <Route path="/register" element={<Register />} />
            <Route path="/rankings" element={<Rankings />} />
            <Route path="/login" element={<Login />} />
            <Route path="/account" element={<Account />} />
            <Route path="/forgot-username" element={<ForgotUsername />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/reset-pic" element={<ResetPIC />} />
            <Route path="/skills" element={<SkillCalculator />} />
            <Route path="*" element={<div className="d-community"><div className="d-wrap d-section"><h1>Page not found.</h1><p>This page may have moved.</p><Link className="d-text-link" to="/">Back to Daruma</Link></div></div>} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
